import React, { memo, useCallback } from 'react'
import { Box, Divider, Flex, Text } from '@chakra-ui/core'
import { ITag } from 'constants/interfaces'
import { CustomCheckBox } from '../GroupsTree/style'
import { RootState } from 'constants/interfaces'
import { useSelector } from 'react-redux'

interface TagRowProps {
  tag: ITag
  isSelected: boolean
  toggleSelection: (id: string) => void
  style: React.CSSProperties
}

export const TagRow = memo(({ tag, isSelected, toggleSelection, style }: TagRowProps) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  const handleToggleSelection = useCallback(() => {
    toggleSelection(tag.sk)
  }, [tag.sk, toggleSelection])

  return (
    <Box style={style} px="15px">
      <Flex alignItems="center" h="60px" style={{ columnGap: '5px' }} justifyContent="space-between">
        <Flex flex="1" isTruncated w="max-content" maxWidth="250px" alignItems="center" style={{ columnGap: '10px' }}>
          <Box
            width="20px"
            height="20px"
            flexShrink={0}
            borderRadius="4px"
            backgroundColor={tag.tag_color || '#94A3B8'}
          />
          <Text fontSize="17px" fontWeight={600} color="#202426">
            {tag.name}
          </Text>
        </Flex>
        <CustomCheckBox
          aria-label={tag.name}
          color={theme?.elementsColor}
          isChecked={isSelected}
          onChange={handleToggleSelection}
          id={`tag-checkbox-${tag.sk}`}
          name={`tag-checkbox-${tag.name}`}
        />
      </Flex>
      <Divider my={0} />
    </Box>
  )
})
